import { TListResponse } from '.';
import {
  Facility,
  FacilityAddress,
  TClientId,
  TFacilityId,
  TProgramId,
  TRegionId,
  TRetirementReasonId,
  TUtilityId,
} from '/src/lib/models';
import { DateString, Nullable } from '/src/lib/types';

/**
 * List Facilities
 */
export type TListFacilitiesRequest = {
  client_id: TClientId;
  page?: number;
  limit?: number;
  is_active?: boolean;
  is_finalized?: boolean;
  active_by_reporting_quarter?: DateString;
  name?: string;
  program_id?: TProgramId;
  utility_id?: TUtilityId;
  address_line1?: string;
  address_city?: string;
  address_region_id?: string;
  address_postal_code?: string;
};

export type TListFacilitiesResponse = TListResponse<Facility[]> & {
  earliest_first_active_reporting_quarter?: Nullable<DateString>;
};

/**
 * List Facility Addresses
 */
export type TListFacilityAddressesResponse = FacilityAddress[];

/**
 * List All Facilities
 */
export type TListAllFacilitiesRequest = {
  page?: number;
  limit?: number;
  is_active?: boolean;
  name?: string;
  program_id?: TProgramId;
  utility_id?: TUtilityId;
  address_line1?: string;
  address_city?: string;
  address_region_id?: string;
  address_post_code?: string;
};

export type TListAllFacilitiesResponse = TListResponse<Facility[]>;

/**
 * Get Facility
 */
export type TGetFacilityRequest = {
  id: TFacilityId;
};

export type TGetFacilityResponse = Facility;

/**
 * Create Facility
 */
export type TCreateFacilityRequest = {
  client_id: TClientId;
  name: Nullable<string>;
  program_id: Nullable<TProgramId>;
  utility_id: Nullable<TUtilityId>;
  first_active_reporting_quarter: DateString;
  address_line1: string;
  address_line2: Nullable<string>;
  address_city: string;
  address_region_id: TRegionId;
  address_post_code: string;
  comments: Nullable<string>;
};

export type TCreateFacilityResponse = Facility;

/**
 * Update Unfinalized Facility
 */
export type TUpdateUnfinalizedFacilityRequest = {
  id: TFacilityId;
  name: Nullable<string>;
  utility_id: Nullable<TUtilityId>;
  address_line1: string;
  address_line2: Nullable<string>;
  address_city: string;
  address_post_code: string;
  comments: Nullable<string>;
};

export type TUpdateUnfinalizedFacilityResponse = Facility;

/**
 * Update Finalized Facility
 */
export type TUpdateFinalizedFacilityRequest = {
  id: TFacilityId;
  name: Nullable<string>;
  utility_id: Nullable<TUtilityId>;
  comments?: Nullable<string>;
};

export type TUpdateFinalizedFacilityResponse = Facility;

/**
 * Retire Facility
 */
export type TRetireFacilityRequest = {
  facility_ids: TFacilityId[];
  last_active_reporting_quarter: DateString;
  retirement_reason_id: TRetirementReasonId;
  retirement_reason_other?: Nullable<string>;
};

/**
 * Delete Facility
 */
export type TDeleteFacilityRequest = {
  facility_ids: TFacilityId[];
};
